import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

const fmtDay = (d) => new Date(`${d}T00:00:00Z`).toLocaleDateString(undefined, { month: "short", day: "numeric", timeZone: "UTC" });

export default function DailyChart({ data }) {
  return (
    <div className="bg-white rounded-2xl border border-[#E6E1D8] p-5 sm:p-6" data-testid="launch-stats-daily-chart">
      <h2 className="font-semibold text-[16px] text-[#1A2A3A] mb-4">Day by day</h2>
      <div className="h-[280px]">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 4, right: 4, left: -16, bottom: 0 }}>
            <CartesianGrid stroke="#EEE9E0" vertical={false} />
            <XAxis dataKey="date" tickFormatter={fmtDay} tick={{ fontSize: 11, fill: "#5B6B7B" }} minTickGap={16} />
            <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: "#5B6B7B" }} />
            <Tooltip labelFormatter={fmtDay} cursor={{ fill: "#334E68", opacity: 0.06 }} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Bar dataKey="visit" name="Visits" fill="#9FB3C8" radius={[3, 3, 0, 0]} />
            <Bar dataKey="get_started" name="Get started" fill="#334E68" radius={[3, 3, 0, 0]} />
            <Bar dataKey="app_store" name="App Store" fill="#E8712C" radius={[3, 3, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
